import React, {ReactElement, ReactNode} from 'react';
import {Alignment} from '../../../../types';

import './Paragraph.scss';

export enum FontWeight {
  REGULAR = 'weightRegular',
  MEDIUM = 'weightMedium',
  SEMIBOLD = 'weightSemibold',
}

export enum FontSize {
  EXTRA_SMALL = 'sizeExtraSmall',
  EXTRA_LARGE = 'sizeExtraLarge',
  DOUBLE_EXTRA_LARGE = 'sizeDoubleExtraLarge',
  LARGE = 'sizeLarge',
  MEDIUM = 'sizeMedium',
  SMALL = 'sizeSmall',
}

export interface ParagraphProps {
  alignment?: Alignment;
  children?: ReactNode;
  className?: string;
  fontSize?: FontSize;
  fontWeight?: FontWeight;
  italic?: boolean;
  id?: string;
  ref?: React.RefObject<HTMLDivElement>;
}

// @todo future work: spacing (margins etc), line height

function Paragraph({
  alignment = Alignment.LEFT,
  children,
  className,
  fontSize = FontSize.LARGE,
  fontWeight = FontWeight.REGULAR,
  italic,
  id,
  ref,
}: ParagraphProps): ReactElement {
  return (
    <p
      className={`paragraph paragraph--${fontSize} paragraph--${fontWeight} paragraph--${alignment} ${
        italic ? 'paragraph--italic' : ''
      } ${className || ''}`
        .replace(/\s\s/g, ' ')
        .trim()}
      id={id}
      ref={ref}
    >
      {children}
    </p>
  );
}

export default Paragraph;
